import { cn } from "@/lib/utils";

export default function InvalidText({ label, className }: { label: string; className?: string }) {
	return <span className={cn("hidden [.invalid_&]:block text-sm text-red-600", className)}>{label}</span>;
}
